import { bl_applet_badge_hdr_RowClass } from '../../../dbschema';
import {BaseContainerModel} from '../../base-container.model';

export class AppletBadgeContainerModel extends BaseContainerModel {
    bl_applet_badge_hdr: bl_applet_badge_hdr_RowClass = new bl_applet_badge_hdr_RowClass();
}
